/* Use Dawn's form so cart sections, errors, quantities and gift cards stay in sync. */
(function () {
  if (customElements.get('sticky-add-to-cart')) return;
  class StickyAddToCart extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.productForm = this.productInfo?.querySelector('product-form');
      this.mainButton = this.productForm?.querySelector('[type="submit"]');
      if (!this.mainButton) return;
      this.button = this.querySelector('.wp-sticky-atc__btn');
      this.label = this.button.querySelector('.wp-sticky-atc__btn-label');
      this.quantity = this.querySelector('.wp-sticky-atc__qty input');
      this.mainQuantity = this.productInfo.querySelector('.quantity__input');
      if (!this.mainQuantity && this.quantity) {
        this.quantity.name = 'quantity';
        this.quantity.setAttribute('form', this.productForm.form.id);
      }
      this.error = this.querySelector('[data-sticky-error]');
      this.onChange = () => this.sync();
      this.productInfo.addEventListener('change', this.onChange);
      this.button.addEventListener('click', () => {
        this.sync();
        if (this.button.disabled) return;
        if (this.mainQuantity && !this.mainQuantity.reportValidity()) {
          this.mainQuantity.scrollIntoView({ block: 'center' });
          return;
        }
        if (!this.mainQuantity && this.quantity && !this.quantity.reportValidity()) return;
        this.mainButton.click();
        this.sync();
      });
      this.quantity?.addEventListener('change', () => {
        if (!this.quantity.reportValidity()) return;
        if (this.mainQuantity) {
          this.mainQuantity.value = this.quantity.value;
          this.mainQuantity.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      this.querySelectorAll('.wp-qty-minus, .wp-qty-plus').forEach((button) => {
        button.addEventListener('click', () => {
          if (!this.quantity) return;
          button.classList.contains('wp-qty-plus') ? this.quantity.stepUp() : this.quantity.stepDown();
          this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      this.stateObserver = new MutationObserver(() => this.sync());
      this.stateObserver.observe(this.productForm, {
        subtree: true, childList: true, characterData: true, attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class', 'hidden']
      });
      if (this.mainQuantity) this.stateObserver.observe(this.mainQuantity, { attributes: true });
      this.unsubscribers = [];
      if (typeof subscribe === 'function') {
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.quantityUpdate, () => this.sync()));
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.productInfo.dataset.section || (data.productInfoId && data.productInfoId !== this.productInfo.id)) return;
          const freshBar = data.html.querySelector('sticky-add-to-cart');
          ['.wp-sticky-atc__price', '.wp-sticky-atc__thumb'].forEach((selector) => {
            const fresh = freshBar?.querySelector(selector);
            const current = this.querySelector(selector);
            if (fresh && current) current.innerHTML = fresh.innerHTML;
          });
          this.sync();
        }));
      }
      this.visibilityObserver = new IntersectionObserver(([entry]) => {
        const visible = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        this.classList.toggle('wp-sticky-atc--visible', visible);
        this.setAttribute('aria-hidden', String(!visible));
        this.toggleAttribute('inert', !visible);
        this.querySelectorAll('button, input').forEach((control) => control.tabIndex = visible ? 0 : -1);
        document.body.classList.toggle('wp-sticky-atc-active', visible);
      }, { threshold: 0 });
      this.visibilityObserver.observe(this.productInfo.querySelector('.product-form__buttons'));
      this.sizeObserver = new ResizeObserver(() => {
        document.body.style.setProperty('--wp-sticky-atc-height', this.getBoundingClientRect().height + 'px');
      });
      this.sizeObserver.observe(this);
      this.sync();
    }
    sync() {
      const busy = this.mainButton.classList.contains('loading');
      const disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
      this.button.disabled = disabled;
      this.button.setAttribute('aria-disabled', String(disabled));
      this.button.setAttribute('aria-busy', String(busy));
      this.label.textContent = busy ? 'Adding…' : this.mainButton.querySelector('span').textContent.trim();
      const mainError = this.productForm.querySelector('.product-form__error-message-wrapper');
      this.error.textContent = mainError && !mainError.hidden
        ? mainError.querySelector('.product-form__error-message').textContent : '';
      this.error.hidden = !this.error.textContent;
      if (!this.quantity) return;
      if (this.mainQuantity) {
        ['min', 'max', 'step'].forEach((name) => {
          const value = this.mainQuantity.getAttribute(name);
          value === null ? this.quantity.removeAttribute(name) : this.quantity.setAttribute(name, value);
        });
        this.quantity.value = this.mainQuantity.value;
      }
      this.quantity.disabled = disabled;
      this.querySelector('.wp-qty-minus').disabled = disabled || Number(this.quantity.value) <= Number(this.quantity.min || 1);
      this.querySelector('.wp-qty-plus').disabled = disabled || (this.quantity.max !== '' && Number(this.quantity.value) >= Number(this.quantity.max));
    }
    disconnectedCallback() {
      this.productInfo?.removeEventListener('change', this.onChange);
      this.stateObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.sizeObserver?.disconnect();
      if (!document.querySelector('sticky-add-to-cart.wp-sticky-atc--visible')) {
        document.body.classList.remove('wp-sticky-atc-active');
        document.body.style.removeProperty('--wp-sticky-atc-height');
      }
      this.unsubscribers?.forEach((unsubscribe) => unsubscribe());
    }
  }
  customElements.define('sticky-add-to-cart', StickyAddToCart);
})();
